import { render, staticRenderFns } from "./HistoryExam.vue?vue&type=template&id=43d1f6c9&"
import script from "./HistoryExam.vue?vue&type=script&lang=js&"
export * from "./HistoryExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports